import { useState } from 'react';
import { Link } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { AccountCardSmallTile } from './small/card';
import { AccountPaymentSmallTile } from './small/payment';

interface IAccountTileSmallProps {
  account: AccountResponse;
  subAccounts?: AccountResponse[];
  isOrphanSub?: boolean;
  currency?: string;
}

export const AccountTileSmall = (props: IAccountTileSmallProps) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  return (
    <>
      {props.account.type === AccountType.Card ? (
        <Link
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => {
            e.preventDefault();
            setIsDragging(true);
          }}
          onDragEnd={() => setIsDragging(false)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          <AccountCardSmallTile account={props.account} />
        </Link>
      ) : (
        <Link
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => {
            e.preventDefault();
            setIsDragging(true);
          }}
          onDragEnd={() => setIsDragging(false)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          <AccountPaymentSmallTile
            accounts
            account={props.account}
            subAccounts={props.subAccounts!}
            isOrphanSub={props.isOrphanSub}
            currency={props.currency}
          />
        </Link>
      )}
    </>
  );
};
